import { render, staticRenderFns } from "./gasClampRamp.vue?vue&type=template&id=2aad56c4&scoped=true"
import script from "./gasClampRamp.vue?vue&type=script&lang=js"
export * from "./gasClampRamp.vue?vue&type=script&lang=js"
import style0 from "./gasClampRamp.vue?vue&type=style&index=0&id=2aad56c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aad56c4",
  null
  
)

export default component.exports